// extracted by mini-css-extract-plugin
export var container = "_6r-0";
export var infoButton = "_6r-1";
export var label = "_6r-3";
export var labelExpanded = "_6r-4";
export var price = "_6r-5";
export var priceExpanded = "_6r-6";
export var title = "_6r-2";